import { Molecule } from "AppReact";
import styled from "styled-components";
import { Icon, UnColoredSecondaryTextXs } from "atoms";
import { CloseSvg } from "components/icons";
import ButtonWrapper from "./wrapper";


export const template = styled.div``;

export default Molecule({
  template,
  type: "button",
  atoms: [
    {
      wrapper: ButtonWrapper,
      name: "ButtonWrapper",
      displayState: ({ color }) => ({ color }),
      atoms: [
        {
          component: UnColoredSecondaryTextXs,
          name: "Icon",
          displayValue: ({ text }) => text,
          displayState: ({ color }) => ({ color }),
        },
        {
          component: Icon,
          name: "Close",
          displayValue: ({}) => CloseSvg({ width: 17, height: 17 }),
        },
      ],
    },
  ],
});
